import React from 'react';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import {
  humanBodyHB,
  humanBodyDNA,
  humanBodyDNAFull,
} from 'on_web/assets/imageList';
import SpecificRisk from './SpecificRisk';

export default function RisksOnHumanBody(props) {
  const { isDesktop, data } = props;
  const useStyles = makeStyles(theme => ({
    title: {
      fontFamily: 'Museo-500',
      fontSize: 22,
      lineHeight: 1.19,
      color: '#2a343f',
      paddingBottom: props.isDesktop ? 35 : 0,
    },
  }));

  const classes = useStyles();

  return (
    <Box
      style={{
        borderTop: isDesktop ? 'none' : '1px Solid #efefef',
        paddingBottom: isDesktop ? 0 : '20px',
        marginTop: isDesktop ? '40px' : 0,
      }}
    >
      <Grid container direction={isDesktop ? 'column' : 'column-reverse'}>
        <Grid item>
          <Box
            style={{
              paddingTop: isDesktop ? 0 : 20,
              paddingRight: isDesktop ? 0 : 25,
              backgroundImage: `url(${
                data.length >= 5
                  ? data.length === 5
                    ? humanBodyDNAFull
                    : humanBodyHB
                  : humanBodyDNA
              })`,
              backgroundSize: 'inherit',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: isDesktop ? 'center' : '99% 50%',
            }}
          >
            {data.length <= 5 && (
              <Box
                style={{
                  height: isDesktop
                    ? data.length < 3
                      ? 140
                      : 70
                    : data.length < 3
                    ? 70
                    : 10,
                }}
              ></Box>
            )}
            <Grid container justify="center" style={{ paddingTop: '20px' }}>
              {data.map(item => {
                return (
                  <Grid item xs={isDesktop ? 6 : 12}>
                    <Box
                      display="flex"
                      justifyContent={isDesktop ? 'center' : 'flex-end'}
                      alignItems="center"
                    >
                      <SpecificRisk
                        notPurchased={props.notPurchased}
                        risk={item}
                        isDesktop={isDesktop}
                        onLabelClicked={label => {
                          if (props.onLabelClicked) {
                            props.onLabelClicked(label);
                          }
                        }}
                      />
                    </Box>
                  </Grid>
                );
              })}
              <Box style={{ height: data.length < 5 ? 160 : 40 }}></Box>
            </Grid>
          </Box>
        </Grid>
        <Grid item>
          <Box
            className={classes.title}
            style={{
              paddingTop: '20px',
              textAlign: 'center',
            }}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <div>
              <span>{props.title}</span>
            </div>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
